var Stylers = {
  category: require('./category'),
  histogram: require('./histogram')
};

module.exports = {
  get: function (dataviewModel, layerModel, style) {
    var AutoStyler = Stylers[dataviewModel.get('type')];
    if (AutoStyler) {
      return new AutoStyler(dataviewModel, layerModel, style);
    } else {
      throw new Error('dataview type not supported');
    }
  }
};



//////////////////
// WEBPACK FOOTER
// ./lib/assets/javascripts/deep-insights/widgets/auto-style/factory.js
// module id = 615
// module chunks = 0 2